module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAgCAYAAAABtRhCAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAS1JREFUeNpiYGBgUADis0C8gIG2YBMQHwMxsoD4PxS30ciyiUh2MPAD8RUkgXQqW1aKZPYRmKAkEP9BkjCkkmW2SGZ+AmIeZElHJMmPQCxIoWUgT/xEMtMYmyLk+LxAoYV3kMyKxqewGUnhRjItO4BkRhkxGvZRkHInIOldR6wmdiB+jqQxiEh9CUh6rpMaLCpImkFYh4B6EyS1X4FYjJy4cEBLuZI41MlA5WFq9ShJbdlIBl3DoeYhkppQamTghUgGLkaTW4sk10fNIuokksHFULEqJLHdxBpEbG0BSrl3kSyYhcQGlcWMtKgtpNBSLgj/AGI+WtYWfmgWOtCjtigB4ltAnDpaW4zWFqO1xWhtMThrC1JSLiW1BVmA3NqCIkBqbUEVQGxtgQEAAgwAGlDNq6uBhgIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/android/bottom.png
// module id = J4g3
// module chunks = 0